/** Radians: π = left, 0 = right, π/2 = top (upward-opening arch). */
function polarRad(cx: number, cy: number, r: number, angleRad: number) {
  return {
    x: cx + r * Math.cos(angleRad),
    y: cy - r * Math.sin(angleRad),
  };
}

/** Donut segment on an upward-opening semicircle (∩). */
export function describeDonutArcRad(
  cx: number,
  cy: number,
  innerR: number,
  outerR: number,
  startRad: number,
  endRad: number
): string {
  if (startRad <= endRad) return '';

  const outerStart = polarRad(cx, cy, outerR, startRad);
  const outerEnd = polarRad(cx, cy, outerR, endRad);
  const innerEnd = polarRad(cx, cy, innerR, endRad);
  const innerStart = polarRad(cx, cy, innerR, startRad);
  const span = startRad - endRad;
  const largeArc = span > Math.PI ? 1 : 0;

  return [
    `M ${outerStart.x} ${outerStart.y}`,
    `A ${outerR} ${outerR} 0 ${largeArc} 1 ${outerEnd.x} ${outerEnd.y}`,
    `L ${innerEnd.x} ${innerEnd.y}`,
    `A ${innerR} ${innerR} 0 ${largeArc} 0 ${innerStart.x} ${innerStart.y}`,
    'Z',
  ].join(' ');
}

/** SP boundary: π (left) toward 0 (right). */
export function semiDonutSplitRad(spPct: number): number {
  const clamped = Math.min(100, Math.max(0, spPct));
  return Math.PI - (clamped / 100) * Math.PI;
}

export function arcMidpointRad(
  cx: number,
  cy: number,
  r: number,
  startRad: number,
  endRad: number
) {
  return polarRad(cx, cy, r, (startRad + endRad) / 2);
}

/** Map value to bar height (0–maxHeight). */
export function barHeight(value: number, max: number, maxHeight: number): number {
  if (max <= 0 || value <= 0) return 0;
  return Math.max(4, (value / max) * maxHeight);
}
